import { VenueDetailsType } from '@api';
import {
  Anchor,
  getValueByPath,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
  useFormatAddress,
} from '@common';
import { useTranslation } from 'react-i18next';
import { GeneralInformationTableRowType } from '../../types';
import { Coordinates } from './components';

type GeneralInformationTableRowPropsType = {
  venue: VenueDetailsType;
  row: GeneralInformationTableRowType;
};

export const GeneralInformationTableRow: React.FC<
  GeneralInformationTableRowPropsType
> = ({ venue, row }) => {
  const { t } = useTranslation('venueDetailsGeneral');
  const { formatAddressMultiLine } = useFormatAddress();

  const getRenderValue = () => {
    const value = getValueByPath(venue, row.accessor);
    const noDataPlaceholder = t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    if (!value) return noDataPlaceholder;

    switch (row.accessor) {
      case 'address':
        return formatAddressMultiLine(venue.address);
      case 'category':
        return t(`CATEGORIES.${venue.category}`, { ns: 'venues' });
      case 'coordinates':
        if (!venue.coordinates) return noDataPlaceholder;
        return <Coordinates coordinates={venue.coordinates} />;
      case 'website':
        return (
          <Anchor to={venue.website} target="_blank">
            {venue.website}
          </Anchor>
        );
      default:
        return String(value);
    }
  };

  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>
        {t(`GENERAL_INFORMATION.ROWS.${row.label}`)}
      </TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
